<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
          <el-row :gutter="24">
           
            <el-col :span="8">
              <el-form-item label="设备IMEI号" prop="deviceSerial">
                
                <el-input
                  clearable
                  disabled
                   v-model="form.deviceSerial"
                  
                  maxlength="100"
                ></el-input> 
               
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备编号" prop="code">
                
                <el-input
                  clearable
                  disabled v-model="form.code"
                 
                  maxlength="100"
                ></el-input> 
               
              </el-form-item>
            </el-col>
  
            <el-col :span="8">
              <el-form-item label="设备名称" prop="name"> 
  
  
                <el-input
                  clearable
                  disabled
                   v-model="form.name"
                  
                  maxlength="20"
                ></el-input> 
                
              </el-form-item>
            </el-col>
  
            <el-col :span="8">
              <el-form-item label="绑定老人" prop="elderlyId"> 
  
  
                <el-select
                   v-model="form.elderlyId"
                  style="width: 100%"
                  placeholder="绑定老人"
                  @change="elderlyIdChange"
                >
                  <el-option
                    v-for="item in oldPeopleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
  
              </el-form-item>
            </el-col>
  
            <el-col :span="8">
              <el-form-item label="联系方式" prop="tel">
                
                <el-input
                  clearable
                   disabled v-model="form.tel"
               
                  maxlength="100"
                ></el-input> 
               
              </el-form-item>
            </el-col>
  
            <el-col :span="8">
              <el-form-item label="身份证号" prop="idNumber">
                
                <el-input
                  clearable
                   disabled v-model="form.idNumber"
                 
                  maxlength="100"
                ></el-input> 
                        
              </el-form-item>
            </el-col>
           
          </el-row>
        </el-form>
      </div>
      <div style="text-align: right" v-if="model != 'view'">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
            提交
        </el-button>
        <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
      </div>
    </div>
  </template>
    <script>
  import { getProjectList } from '@/api/crmedical/project/project';
  import { getDictionary } from '@/api/common.js';
  import {smartDeviceSave,smartDeviceUpdate ,getSmartDeviceDetail,nursinglist } from '@/api/nursingHome/elderDevice';
  export default {
    components: {},
    props: {
      row: {
        default: {},
      },
      nursinghomeId: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        projectList: [],
        provideList: [
        ],
        form: {
          nursinghomeId: '',
          downWarnValue: '',
          upWarnValue: '',
          releaseMode:""
        },
        formRules: {
          elderlyId: [{ required: true, message: '绑定老人不能为空', trigger: 'change' }],
      
        },
        matetialList: [],
        deviceCategoryList: [],
        userList: [],
        deviceTypeIdList: [],
        deviceModelIdList: [],
        nursinghomeIdList: [],
        paymentTypeList: [],
        oldPeopleList:[],
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
      elderlyIdChange(){
        
        this.form.idNumber=""
            this.form.tel=""
        this.oldPeopleList.forEach(item=>{
          if(item.id==this.form.elderlyId){
           
            this.form.idNumber=item.idNumber
            this.form.tel=item.tel
          }
        })
      },
    
       initData() {
        nursinglist({id:this.row.nursinghomeId}).then((res)=>{
          this.oldPeopleList=res.data
          getSmartDeviceDetail({id:this.row.id}).then(res=>{
          this.form = res.data
          this.oldPeopleList.forEach(item=>{
          if(item.id==this.form.elderlyId){
           
            this.form.idNumber=item.idNumber
            this.form.tel=item.tel
          }
        })
        })
        })
       
       
      },
      saveRecord() {
        this.$refs['formRef'].validate((valid) => {
            if (valid) {
              smartDeviceUpdate(this.form).then((res) => {
                this.$message.success('绑定成功');
                this.$emit('success');
              });
            }
          });
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
  </script>
    <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
    